import React, { PropsWithChildren } from 'react'
import styled from '~/app/components/styled'

/**
 * Card component
 * author: soojin.oh
 */

// styled components
const Container = styled.div`
  border-radius: 0.8rem;
  border: solid 0.1rem ${({ theme }) => theme.color.gray200};
  background: ${({ theme }) => theme.color.white};
  position: relative;
  z-index: 0;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-flow: wrap;

  margin: 0 0 1.6rem;
  :nth-of-type(1) {
    margin-top: 1.1rem;
  }
  :nth-last-of-type(1) {
    margin-bottom: 2rem;
  }

  &.has-shadow {
    box-shadow: 0 2px 4px 0 ${({ theme }) => theme.color.black_op5};
  }
`

type CardProps = {
  className?: string
  style?: React.CSSProperties
  hasShadow?: boolean
}

// Card component
const Card = function ({
  children,
  className = '',
  style,
  hasShadow = true,
}: PropsWithChildren<CardProps>) {
  const classes = [className, hasShadow ? 'has-shadow' : ''].join(' ')
  return (
    <Container className={classes} style={style}>
      {children}
    </Container>
  )
}

export default Card
